exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-d88e6596]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100vh;background:#ff847b;color:white}.icon[data-v-d88e6596]{font-size:45px;margin:5px}.link[data-v-d88e6596]{text-decoration:underline;cursor:pointer}.row[data-v-d88e6596]{-ms-flex-pack:center;justify-content:center;text-align:center}div[data-v-d88e6596]{text-align:center;line-height:25px}div>*[data-v-d88e6596]{width:100%}\n", ""]);

// exports
